var NewsSearch = {
    newsResultsPerPage: 9,
    newsExcludeId: 0,
    newsRootId: 0,
    newsCurrentResultPage: 1,

    docType: "newsArticle",
    partialView: "NewsResult_Rows",

    newsResultTarget: null,
    loadMoreTarget: null,
    buttonTabs: null,

    me: this,

    InitNewsSearch: function (_resultsPerPage, _highlightedArticle, _rootId, eventToggle) {
        this.newsResultsPerPage = _resultsPerPage;
        this.newsExcludeId = _highlightedArticle;
        this.newsRootId = _rootId;
        this.newsResultTarget = document.querySelector('#search_results');
        this.buttonTabs = document.getElementById('buttonTabs');
        this.eventToggle = eventToggle;
        document.querySelector('#eventToggle').value = eventToggle.value;

        this.buttonTabs.addEventListener('click', (e) => {
            if (e.target.tagName === 'BUTTON') {
                var buttonTab = this.buttonTabs.querySelectorAll('button');
                buttonTab.forEach(b => b.classList.remove('active'));
                e.target.classList.add('active');
            }
        });

        document.querySelectorAll('.search__aggregation input[type=checkbox]').forEach(function (key) {
            key.addEventListener("change", function (e) {
                e.preventDefault();
                this.DoSearch();
            }.bind(this));
        }.bind(this));

        this.DoSearch();
    },

    DoSearch: function () {
        let prom = this.GetSearchResults(1);
        prom.then(
            function (result) {
                $('#search__results').html(result.htmlResults);
                $('#pagination_search').pagination({
                    items: result.totalResultCount,
                    itemsOnPage: this.newsResultsPerPage,
                    cssStyle: 'light-theme',
                    onPageClick: function (pageNumber, event) {
                        this.DoAjaxSearch(pageNumber);
                        scrollToAnchorIDOffset('topOfSearch'); ('topOfSearch');
                    }.bind(this),
                    onInit: function () {
                        console.log('Init paging');
                        var resultCount = 0;
                        if (result.totalResultCount !== null) {
                            resultCount = result.totalResultCount;
                        }
                        this.DoPagination(resultCount, 1);
                    }.bind(this)
                });
            }.bind(this)   // Bind the parent scope to this
        );
    },

    SetToggle: function (toggleValue) {
        this.eventToggle = toggleValue;
        document.querySelector('#eventToggle').value = toggleValue.value;
        this.newsCurrentResultPage = 1;  // Reset the pagination
        this.DoSearch(); // Trigger a new search with the updated news/events toggle
    },

    GetSearchParams: function (pageNo) {
        var peopleFilter = nodeListToIds(document.querySelectorAll('.search__aggregation input[type=checkbox][data-group="people"]'));
        var categoryFilter = nodeListToIds(document.querySelectorAll('.search__aggregation input[type=checkbox][data-group="newsCategories"]'));

        var params = {
            resultsPerPage: this.newsResultsPerPage,
            rootNode: this.newsRootId,
            excludeId: this.newsExcludeId,
            currentResultPage: pageNo,
            docType: this.docType,
            partialView: this.partialView,
            dateFilterField: 'displayDateIndex',
            eventToggle: this.eventToggle,  // Pass the toggle value to the controller

            // Facets
            people: peopleFilter,
            filterCategories: categoryFilter
        };

        console.log(params);

        return params;
    },

    DoPagination: function (resultCount, currentPage) {
        var $pagination = $('#pagination_search');

        console.log('Page results count : %o - Per page : %o', resultCount, this.newsResultsPerPage);

        if (resultCount !== null && resultCount > this.newsResultsPerPage) {
            $pagination.pagination('destroy');
            $pagination.pagination('updateItems', resultCount);
            $pagination.pagination('drawPage', currentPage);
            $pagination.show();
        } else {
            $pagination.hide();
        }
    },

    DoAjaxSearch: function (pageNo) {
        var prom = this.GetSearchResults(pageNo);
        prom.then(
            function (result) {
                console.log("Processing ajax results : %o", result);

                $('#search__results').html(result.htmlResults);

                this.DoPagination(result.totalResultCount, pageNo);

                scrollToAnchorIDOffset('topOfSearch');
            }.bind(this)
        );
    },

    GetSearchResults: function (pageNo) {
        let searchParams = this.GetSearchParams(pageNo);
        console.log(searchParams);
        return new Promise(function (resolve, reject) {
            fetch('/umbraco/surface/NewsSearch/DoNewsSearchView', {
                body: JSON.stringify(searchParams), method: 'post', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
            })
                .then(function (response) {
                    //console.log('response : %o', response.json());
                    resolve(response.json());
                })
                .catch(error => {
                    console.log('Failed', error);
                    reject(error);
                });
        });
    }
}